<template>
  <svg
    width="32"
    viewBox="0 0 48 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M43.17 27.1085C37.6201 24.3957 32.9793 19.9934 30.097 14.5486C29.3843 16.5622 28.5409 18.4462 27.5017 20.2659C30.4465 24.5424 34.3679 28.1027 38.874 30.6881L34.253 34.7227C30.3342 32.2657 26.9354 29.0936 24.1226 25.4658C21.3268 29.1068 17.8776 32.2301 14.0357 34.7702L9.33076 30.8223C13.8899 28.2156 17.7293 24.6371 20.654 20.3468C19.6063 18.5321 18.7539 16.5871 18.0319 14.6418C15.11 20.1003 10.5551 24.5242 5.01805 27.2629L0.0516366 23.0561C9.10921 19.7898 15.6107 11.1429 15.5869 1.01853L21.3912 1.00491C21.4021 5.61278 22.3255 10.0238 24.0306 14.0436C25.7168 10.0159 26.6194 5.60054 26.6086 0.992664L32.413 0.979041C32.4367 11.1034 38.9787 19.7197 48.0515 22.9434L43.17 27.1085Z"
    ></path>
  </svg>
</template>
